import HipAPI from '@/lib/HipApi';

const hipApi = HipAPI.getInstance();

const state = () => ({
    properties: [],
    propertiesLoading: false,
});

const mutations = {
    setProperties(state: any, payload: any) {
        state.properties = payload.properties;
    },
    setPropertiesLoading(state: any, payload: any) {
        state.propertiesLoading = payload;
    },
};

const actions = {
    getProperties({ commit, state }: any) {
        commit('setPropertiesLoading', true);
        hipApi.getProperties()
            .then((res: any) => {
                commit('setProperties', { properties: res });
            })
            .catch((err) => {
                commit('notificationDialog/showMessage', { type: 'error', title: 'Error', msg: err?.error?.message || err?.message || err }, { root: true });
            })
            .finally(() => {
                commit('setPropertiesLoading', false);
            });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
